<template>
  <div class="CoursePoster" v-show="showPoster && imgLoaded">
    <div class="content" ref="content">
      <img v-if="src" class="poster" :src="src" @load="imgLoaded = true">
      <img class="btn-close" src="@/assets/svg/group-10.svg" @click="handleClosePoster()">
      <div class="share_qrcode">
        <span>扫码分享，专属海报</span>
        <img :src="qrCode" alt="">
      </div>
    </div>
    <VuiButton class="btn-save" type="warning" round @click.native="download">保存</VuiButton>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { COURSE_STATE } from '@/constant/constants'
import QRCode from 'qrcode'
export default {
  name: 'CoursePoster',
  props: {
    courseId: String,
    state: Number,
  },
  data () {
    return {
      imgLoaded: false,
      src: '',
      qrCode: '',
    }
  },
  computed: {
    ...mapState('course', ['showPoster']),
  },
  watch: {
    showPoster (newVal) {
      if (newVal && !this.src) {
        this.init()
      }
    },
    state (newVal) {
      if (this.state === COURSE_STATE.LIVING) {
        this.init()
      }
    },
  },
  created () {
    if (this.state === undefined || this.state >= COURSE_STATE.LIVING) {
      this.init()
    }
  },
  methods: {
    init () {
      this.$store
        .dispatch('course/getCoursePosters', {
          source: this.courseId,
        })
        .then((src) => {
          this.src = src
          this.generateQrCode(src)
        })
    },
    download () {
      window.location.href = this.src
    },
    handleClosePoster () {
      this.$store.commit('course/setShowPoster', false)
    },
    generateQrCode (src) {
      let that = this
      let url = window.location.origin + '/#/share?src=' + encodeURIComponent(src)
      QRCode.toDataURL(url, {
        color: {
          dark: '#515a6e',
        },
      },
      (err, qrCodeUrl) => {
        console.log(err)
        that.qrCode = qrCodeUrl
      })
    },
  },
}
</script>

<style lang="scss">
.CoursePoster {
  @include pos(fixed, 0, 0, 0, 0, 102);
  padding: 30px 10px;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.65);

  .content {
    position: relative;
    width: 300px;
    margin: 150px auto 0;
    .share_qrcode {
      display: flex;
      position: absolute;
      align-items: center;
      width: 100%;
      height: 135px;
      bottom: 0;
      padding: 12px;
      font-size: 14px;
      background: #fff;
      justify-content: space-around;
      color: #515a6e;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }

  .poster {
    width: 300px;
    border-radius: 8px;
  }

  .btn-close {
    @include pos(absolute, 0, auto, auto, 0);
    transform: translate(-50%, -50%);
    cursor: pointer;
  }

  .btn-save {
    width: 180px;
    display: block;
    margin: 20px auto;
  }

  .tip {
    @include wh(100%, 84px);
    padding: 0 29px;
    display: flex;
    justify-content: flex-end;

    .tip-text {
      @include font(14px, 20px, #ffffff);
      margin-right: 9px;
      align-self: flex-end;
    }

    .tip-img {
      align-self: flex-start;
    }
  }

  .spin {
    background-color: transparent;
  }
}
</style>
